import useRouteQuery from '@/utils/useRouteQuery/useRouteQuery';

export default useRouteQuery;
